if (typeof document === "undefined") return;
var createStylesheet = (chunkId, fullhref, oldTag, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	if (__webpack_require__.nc) {
		linkTag.nonce = __webpack_require__.nc;
	}
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && event.type;
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + errorType + ": " + realHref + ")");
			err.name = "ChunkLoadError";
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;


	if (oldTag) {
		oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
	} else {
		document.head.appendChild(linkTag);
	}
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	"client-af64eea1": 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"vendors-node_modules_pnpm_tkww_orion-web-contrib-vendor-card_2_1_6__tkww_orion-web-app-kernel-e68888":1,"vendors-node_modules_pnpm_tkww_orion-web-ds-structure_1_5_23__tkww_orion-web-app-kernel_2_9_0-d0210a":1,"apps_marketplace-web_client_components_FavoritesMembershipModal_FavoritesMembershipModal_scss-597e49":1,"apps_marketplace-web_client_components_shared_Breadcrumbs_index_tsx-apps_marketplace-web_clie-349d15":1,"node_modules_pnpm_xo-union_tk-component-location-typeahead_12_0_15__tkww_orion-web-app-kernel-67a96f":1,"state":1,"vendors-node_modules_pnpm_tkww_orion-web-ds-action_1_9_30-alpha_8__tkww_orion-web-app-kernel_-36d817":1,"vendors-node_modules_pnpm_tkww_orion-web-ds-action_1_9_29__tkww_orion-web-app-kernel_2_9_0__t-d84811":1,"apps_marketplace-web_client_components_unified-lightbox_Lightbox_tsx-apps_marketplace-web_cli-2588f7":1,"apps_marketplace-web_client_components_footer_categories_styles_scss-apps_marketplace-web_cli-eba97c":1,"apps_marketplace-web_lib_vendor-recommendation-module_VRM_tsx-apps_marketplace-web_client_com-bc1589":1,"storefront-59ac198a":1,"storefront-deff48e9":1,"storefront-e8ac5e3d":1,"storefront-0f7e0fe6":1,"storefront-425790d4":1,"photos":1,"apps_marketplace-web_client_components_card_styles_scss-apps_marketplace-web_client_component-6d2a62":1,"city-8d2f5433":1,"vendors-node_modules_pnpm_tkww_orion-web-ds-input_1_8_1__tkww_orion-web-app-kernel_2_9_0__tkw-3c0020":1,"deals":1,"category":1,"review-wedding-vendors":1,"best-of-weddings":1,"ai-usage-policy":1,"legal-ai":1,"apps_marketplace-web_lib_mcvrm_index_ts":1,"mcvrm":1,"vrm":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr

// no prefetching

__webpack_require__.H.miniCss = (chunkId) => {
	if((!__webpack_require__.o(installedCssChunks, chunkId) || installedCssChunks[chunkId] === undefined) && /^(a(pps_marketplace\-web_(client_components_(FavoritesMembershipModal_FavoritesMembershipModal_scss\-597e49|card_styles_scss\-apps_marketplace\-web_client_component\-6d2a62|footer_categories_styles_scss\-apps_marketplace\-web_cli\-eba97c|shared_Breadcrumbs_index_tsx\-apps_marketplace\-web_clie\-349d15|unified\-lightbox_Lightbox_tsx\-apps_marketplace\-web_cli\-2588f7)|lib_(mcvrm_index_ts|vendor\-recommendation\-module_VRM_tsx\-apps_marketplace\-web_client_com\-bc1589))|i\-usage\-policy)|c(ategory|ity\-8d2f5433|lient\-41b55204)|st(orefront\-(0f7e0fe6|425790d4|59ac198a|deff48e9|e8ac5e3d)|ate)|v(endors\-(node_modules_pnpm_tkww_orion\-web\-(ds\-(action_1_9_(29__tkww_orion\-web\-app\-kernel_2_9_0__t\-d84811|30\-alpha_8__tkww_orion\-web\-app\-kernel_\-36d817)|input_1_8_1__tkww_orion\-web\-app\-kernel_2_9_0__tkw\-3c0020|spinner_1_1_74__tkww_orion\-web\-app\-kernel_2_9_0__\-4fee9a|structure_1_5_23__tkww_orion\-web\-app\-kernel_2_9_0\-d0210a)|app\-kernel_2_9_0__tkww_orion\-web\-types_1_7_16_react_\-c0535c|contrib\-vendor\-card_2_1_6__tkww_orion\-web\-app\-kernel\-e68888)|xo\-union\-styles)|rm)|(best\-of\-wedding|deal|photo|review\-wedding\-vendor)s|legal\-ai|mcvrm|node_modules_pnpm_xo\-union_tk\-component\-location\-typeahead_12_0_15__tkww_orion\-web\-app\-kernel\-67a96f)$/.test(chunkId)) {
		installedCssChunks[chunkId] = null;
		var link = document.createElement('link');
		link.charset = 'utf-8';
		if (__webpack_require__.nc) {
			link.setAttribute("nonce", __webpack_require__.nc);
		}
		link.rel = "preload";
		link.as = "style";
		link.href = __webpack_require__.p + __webpack_require__.miniCssF(chunkId);
		document.head.appendChild(link);
	}
};